import { atom } from 'recoil';
import { IReminderType } from './ReminderTypeStore';

export interface ICatetory {
  Id: string;
  Name: string;
}

export interface ISubCategory {
  Id: string;
  Name: string;
  IsSystemManaged: boolean;
}

export interface ITimeIntervalType {
  Name: string;
  Description: string;
}

export interface IReminder extends IReminderType {
  ReminderId: string;
  ReminderTypeName: string;
  ReminderTypeCode: string;
  TimeTriggerNextDueDateUtc: string;
  OdometerTriggerNextDueOdometerKm: string;
  TimeTriggerLastCompletedDateUtc: string;
  OdometerTriggerLastCompletedOdometerKm: string;
  CurrentOdometerKm: string;
  AssetId: string;
  AssetPlate: string;
  AssetCode: string;
  StatusName: string;
  OverDueAtLastCompletion: boolean;
  Notes: string;
  AssetMake: string;
  AssetModel: string;
  AssetYearOfManufacture: string;
  AssetTypeId: string;
  AssetVin: string;
  AssetTypeName: string;
  AverageDailyDistanceTravelledKm: string;
  EstimatedDateToReachNextDueOdometer: string;
}

export interface IReminderHistory {
  ReminderHistoryId: string,
  ReminderId: string,
  ReminderTypeId: string,
  ReminderTypeName: string,
  ReminderTypeCode: string,
  CategoryId: string,
  CategoryName: string,
  SubCategoryId: string,
  SubCategoryName: string,
  AssetId: string,
  AssetPlate: string,
  AssetCode: string,
  DueAtTimestampUtc: string,
  CompletedAtTimestampUtc: string,
  DueAtOdometerKm: string,
  CompletedAtOdometerKm: string,
  DueAtOperationalHours: string,
  CompletedAtOperationalHours: string,
  OverDueAtCompletion: boolean,
  OverDueOnDateAtCompletion: boolean,
  OverDueOnOdometerKmAtCompletion: boolean,
  OverDueOnOperationalHoursAtCompletion: boolean
}

export interface IAsset {
  Id: string;
  TenantId: string;
  PlateNumber: string;
  Code: string;
  FleetName: string;
  Make: string;
  Model: string;
  Vin: string;
  YearOfManufacture: string;
  OdometerKm: string;
  OdometerUpdatedTimestampUtc: string;
}


export const timeIntervalTypeState = atom<ITimeIntervalType[]>({
  key: "timeIntervalTypeState",
  default: [
    {
      "Name": "Day",
      "Description": "Day"
    },
    {
      "Name": "Week",
      "Description": "Week"
    },
    {
      "Name": "Month",
      "Description": "Month"
    },
    {
      "Name": "Year",
      "Description": "Year"
    }
  ],
});

export const reminderTabListState = atom<IReminder[]>({
  key: "reminderTabListState",
  default: [],
});

export const reminderTabIndexState = atom<number>({
  key: "reminderTabIndexState",
  default: 0,
});


export const reminderListRefreshState = atom({
  key: "reminderListRefreshState",
  default: true,
});